import React, { useContext, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
    Box
} from "@material-ui/core";
import MROButton from "components/buttons";
import { ToastMessageContext } from "lib/contexts/message_context";
import WarningIcon from "@material-ui/icons/Warning";
import exclamationIcon from "assets/exclamation.png"
import useProgressStyles from "views/Operations/Base/Inprogress/ProgressStyles";

export default function ToolCaution(props) {

    const classes = useProgressStyles()
    const {
        handleClose,
        open = false,
        selectedRows,
        currentSelectedId,
        setCurrentSelectedId
    } = props;
    const message = useContext(ToastMessageContext);
    const [busy, setBusy] = useState(null);
    const [acceptAll, setAcceptAll] = useState(false)

    const [loading, setLoading] = useState(false)

    const [errors, setErrors] = useState({})



    const WarningMessage = ({ message }) => (
        <Grid item style={{ paddingBottom: '12px' }}>
            <Box display="flex" alignItems="center">
                <WarningIcon
                    style={{
                        color: "#FFB300",
                        marginRight: "10px",
                        fontSize: 18,
                    }}
                />
                <Typography style={{ fontSize: "15px" }}>{message}</Typography>
            </Box>
        </Grid>
    );





    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!acceptAll) {
            setCurrentSelectedId(null)
            return;

        }
        else {
            selectedRows.push(currentSelectedId)
            setCurrentSelectedId(null)
            handleClose()
        }
    }



    return (
        <div>


            <Dialog
                maxWidth={"md"}
                fullWidth={true}
                open={open}
                className={classes.toolModal}
                onClose={handleClose}
            >

                <DialogTitle id="customized-dialog-title">
                    <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Box display="flex" alignItems="start">
                            <Typography
                                style={{
                                    fontSize: "18px",
                                }}
                                color="primary"
                            >
                                Transfer Booked Out Tool
                            </Typography>
                            <br />

                        </Box>
                        <Box style={{ position: "relative", left: "-347px", top: "36px" }} >
                            <Typography variant="subtitle2" style={{ fontSize: "14px" }}> Cautions</Typography>
                        </Box>
                        <Box display="flex" justifyContent="center">
                            {" "}
                            <img
                                src={exclamationIcon}
                                alt="Icon"
                                style={{ height: "46px" }}
                            />{" "}
                        </Box>
                    </Box>
                </DialogTitle>

                <DialogContent style={{ marginTop: "10px" }}>

                    <WarningMessage message="Tool will be transferred! (Returned from current job and booked to this job!)" />
                    <WarningMessage message="Confirm tool is serviceable and complete" />

                    <Box pt={3} display="flex" alignItems="center" style={{
                        marginLeft: "11px",
                        paddingBottom: '15px'
                    }}>
                        <span style={{ textDecoration: "underline" }}>Accept ALL Cautions</span>
                        &nbsp;&nbsp;&nbsp;
                        <input
                            // style={{ pointerEvents: popupValues === undefined ? "none" : "" }}
                            type="checkbox"
                            value={acceptAll}
                            onClick={() => {
                                setAcceptAll(!acceptAll);
                            }}
                        />
                    </Box>


                    <Grid className={classes.actionButtons} spacing={1} container style={{ marginTop: "39px", justifyContent: "center" }}>
                        <Grid item>
                            <MROButton
                                type="button"
                                variant={"contained"}
                                onClick={handleClose}
                            >
                                Cancel
                            </MROButton>
                        </Grid>
                        <Grid item>

                            <MROButton
                                loading={loading}
                                variant={"contained"}
                                color={"primary"}
                                style={{ backgroundColor: !acceptAll ? "#FFB300" : "", color: acceptAll ? "#ffff" : "#fff" }}
                                onClick={(e) => {
                                    if (!acceptAll) {
                                        message.showToastMessage({
                                            message: "Cautions must be accepted!",
                                            variant: "error",
                                        });

                                    }
                                    else {
                                        handleSubmit(e)
                                    }
                                }}
                                name="complete1"
                            >
                                Complete
                            </MROButton>
                        </Grid>
                    </Grid>

                </DialogContent>
            </Dialog>
        </div>
    )
}
